// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xVV6U","controls":"styles_controls__avj18","charLimit":"styles_charLimit__TH4_r","input":"styles_input__3an1y","send":"styles_send__1FpmE"};